import { ButtonBase } from '@mui/material';

import { UserInteractionExpansive as UserInteractionExpansiveProps } from '@/components/DynamicForm/types/DynamicFormTypes';
import { strToSlug } from '@/utils';
import { flattenIntoKey } from '@/components/DynamicForm/utils/utils';
import TAGSvgIcon, { IconName } from '@/components/TAGSvgIcon';

import MarkdownText from '../default/MarkdownText/MarkdownText';

import { getUserInteractionExpansiveStyles } from './UserInteraction.styles';

export const UserInteractionExpansive = ({
	copy,
	icon,
	label,
	disabled,
	redirect,
	tagData,
	chevron = 'sm',
	colorScheme = 'default',
	contentVariant = 'default',
}: UserInteractionExpansiveProps) => {
	return (
		<ButtonBase
			className={[
				'user-interaction-expansive-',
				contentVariant === 'default' ? '' : `${contentVariant}-`,
				'root',
			].join('')}
			data-testid={[
				strToSlug(label),
				'-user-interaction',
				contentVariant === 'default' ? '' : `-${contentVariant}`,
			].join('')}
			{...flattenIntoKey(tagData, 'data')}
			title={label}
			disabled={disabled}
			onClick={(e) => {
				e.preventDefault();
				if (redirect) {
					window.location.href = redirect;
				}
			}}
			sx={getUserInteractionExpansiveStyles(contentVariant, colorScheme, chevron)}
		>
			{icon && !!Object.keys(icon).length && <TAGSvgIcon icon={icon.name as IconName} size={icon.size} />}
			<MarkdownText text={copy} />
		</ButtonBase>
	);
};
